import { initGSAP } from "./core/gsap";
import { initImageAndText, initImageAndTextColumns, initHeroBanner } from "./sections";

export function initAnimations() {
  initGSAP(); // global GSAP setup

  // Initialise all sections
  initImageAndText();
  initImageAndTextColumns();
  initHeroBanner();
}